<script>
  import Modal from './Modal.svelte';
  import Button from './Button.svelte';
  import {sgettext} from '../i18n.js';

  export let id = 'confirmationModal';
  export let title = sgettext("$$CONFIRMATION$$");
  export let onYes = () => console.log('yes');
  export let onNo = () => console.log('no');
  export let sending = false;
  export let data = false;
</script>

<style>
  .footer :global(.btn) {margin-left: 5px;}
</style>

<Modal
  {id}
  {title}
  backdrop={'static'}
  onCancel={onNo}
>
  <div slot="body">
    <slot name="message"></slot>
  </div>

  <div class="footer" slot="footer">
    <Button
      type="secondary"
      on:click={onNo}
      name={sgettext("$$NO$$")}
      disabled={sending}
    ></Button>
    {#if data}
      <Button
        type="primary"
        on:click={() => onYes(data)}
        name={sgettext("$$YES$$")}
        {sending}
      ></Button>
    {:else}
      <Button
        type="primary"
        on:click={onYes}
        name={sgettext("$$YES$$")}
        {sending}
      ></Button>
    {/if }

  </div>

</Modal>

